import AudienceUpdateFrequency from './AudienceUpdateFrequency.Container';

export default AudienceUpdateFrequency;
